import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { isB2B } from '@/domains/core/settings/utils';
import { AbTests } from '@/domains/customerFinanceOperations/Payment/AbTests';

export const useIsBillieActive = () => {
  const [billieDE, billieFR] = useBooleanFlags([
    AbTests.BILLIE_DE,
    AbTests.BILLIE_FR,
  ]);
  return isB2B() && (billieDE || billieFR);
};
